export enum ServiceTypeEnum {
  Accessory = "accessory",
  Bonus = "bonus",
  Info = "info",
}
